import { Component, Input, ChangeDetectionStrategy, inject, DestroyRef, ChangeDetectorRef } from '@angular/core';
import { Contract } from '@shared/entities/contract';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-icam-machine-warranty-warning',
  templateUrl: './icam-machine-warranty-warning.component.html',
  styleUrl: './icam-machine-warranty-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IcamMachineWarrantyWarningComponent {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private _themeService = inject(ThemeService);

  isLight = true;
  @Input() contract!: Contract;

  constructor() {
    this._themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => {
          this.isLight = x;
          this._cdr.markForCheck();
        })
      )
      .subscribe();
  }
}
